import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogRef } from "@nebular/theme";
import * as _ from "lodash";
import { Product } from "../../../models/product.model";

import { ProductService } from "../../../services/product.service";

@Component({
  selector: "ngx-dialog-link-product",
  templateUrl: "dialog-link-product.component.html",
  styleUrls: ["dialog-link-product.component.scss"],
})
export class DialogLinkProductComponent implements OnInit {
  @Input() header: string;
  @Input() shopId?: string;

  constructor(
    protected ref: NbDialogRef<DialogLinkProductComponent>,
    private fb: FormBuilder,
    private productService: ProductService
  ) {}

  ngOnInit() {}

  cancel() {
    this.ref.close();
  }

  selected(item) {
    this.ref.close(item);
  }

  onNewProduct() {
    this.ref.close("new");
  }

  removeLink() {
    const value = {
      id: "",
    };
    this.ref.close(value);
  }
}
